import Sandbox from '@nyariv/sandboxjs';
import cloneDeep from 'lodash/cloneDeep';
import * as echarts from 'echarts';
import { get } from 'lodash';

export default {
  name: 'ChartCustomMixin',
  methods: {
    getCustomChartOptions() {
      if (!this.widget.chartOptions.custom.optionGenerator) {
        return {};
      }

      const dataClone = cloneDeep(this.chartData);

      const sandbox = new Sandbox();

      const code = cloneDeep(this.widget.chartOptions.custom.optionGenerator);
      const scope = {
        echarts,
        data: dataClone,
        newEchartsObject: (objectPath, ...args) => {
          const ConstructorOfObject = get(echarts, objectPath);
          const newObject = new ConstructorOfObject(...args);
          return newObject;
        },
        formatDateTime: (value) => {
          const format = get(this.widget, 'chartOptions.dateTimeFormat');
          return this.formatDateTime(value, format);
        },
      };

      const exec = sandbox.compile(code);
      const result = exec(scope).run();

      if (!result) {
        throw new Error('Generator must return an object');
      }

      return result;
    },
  },
};
